<style  lang="scss">
	
</style>

<template>
	<div style="height: 100%;" >
		<!-- table表格 -->
		<yi_curd_table   v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/equipment/check/standard/page"
			getKey="rows" :columns="columns">
			<!-- 搜索框插槽 -->
			<template #conditions>
				<el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
					<el-form-item :label="$t('shebeimingcheng')" rexiauired>
						<yi_cross_select :component="'web_base_equipment_list'" :max="2"
							:ids.sync="yt.conditions.equipmentIds">
						</yi_cross_select>
					</el-form-item>
					<el-form-item>
						<el-button @click="yt.get(1)" type="primary" plain="plain">
							{{$t('sousuo')}}
						</el-button>
						<el-button @click="yt.clear()">{{$t('chongzhi')}}
						</el-button>
					</el-form-item>
					<yi_curd_expand_button></yi_curd_expand_button>
				</el-form>
			</template>
			<!-- 左侧按钮插槽 -->
			<!-- <template #buttonsL>
				<el-button size="mini" @click="yt.showEditDialog('xinzeng',null,'w1')" type="primary">
					{{$t('xinzeng')}}
				</el-button>
				<el-button size="mini" @click="yt.showEditDialog('chongzhidianjianbiaozhun',null,'80%')" plain>
					{{$t('chongzhidianjianbiaozhun')}}
				</el-button>
			</template> -->
			<!-- 右侧按钮插槽 -->
			<template #dianjianzhouqi="scope">
				{{ scope.row.remindType == 1 ? $t('antian') + '-' + scope.row.remind : (scope.row.remindType == 2?$t('anbanci') + '-' + scope.row.remind:scope.row.remind?$t('mei')+scope.row.remind:'')  }}

			</template>
			<!-- 操作插槽 -->
			<template #caozuo="scope">
				<el-row :gutter="10">
					<el-col :span="0.1">
						<el-button type="text"
							@click="yt.showEditDialog('bianji', scope.row)">
							{{$t('bianji')}}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button type="text" class="font-color-danger"
							@click="yt.remove(scope.row,'/web/equipment/check/standard/delete')">{{$t('shanchu')}}
						</el-button>
					</el-col>
				</el-row>
			</template>
		</yi_curd_table>

		<!-- 新增/编辑弹框 -->
		<el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
			:width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
			<!-- 新增表单 -->
			<template v-if="yt.editObj.action == 'xinzeng'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item :label="$t('shebeimingcheng')" required="required">
						<yi_cross_select :max="1" :component="'web_base_equipment_list'"
							:ids.sync="yt.editObj.equipmentId" :isInput="true">
						</yi_cross_select>
					</el-form-item>
					<el-form-item :label="$t('dianjianfenzu')" required="required">
						<el-input v-model="yt.editObj.group"></el-input>
					</el-form-item>
					<el-form-item :label="$t('dianjianneirong')" required="required">
						<el-input type="textarea" v-model="yt.editObj.content"></el-input>
					</el-form-item>
					<el-form-item :label="$t('dianjianzhouqi')" required="required">
						<el-input v-model="yt.editObj.remindTxt" suffix-icon="el-icon-arrow-down" :readonly="true"
							@click.native="showZhouqiDialog()">
						</el-input>
					</el-form-item>
					<el-form-item :label="$t('shifouqiyong')" required>
						<el-select v-model="yt.editObj.enable">
							<el-option :label="$t('shi')" :value="true"></el-option>
							<el-option :label="$t('fou')" :value="false"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item :label="$t('zhuyishixiang')">
						<el-input type="textarea" v-model="yt.editObj.attention"></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="yt.editObj.loading" size="mini"
						@click="yt.req('POST','/web/equipment/check/standard/create')" type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
			</template>
			<!-- 更新表单 -->
			<template v-if="yt.editObj.action == 'bianji'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item :label="$t('shebeimingcheng')" rexiauired>
						<yi_cross_select disabled :max="1" :component="'web_base_equipment_list'"
							:ids.sync="yt.editObj.equipmentId" :isInput="true">
						</yi_cross_select>
					</el-form-item>
					<el-form-item :label="$t('dianjianfenzu')" required="required">
						<el-input v-model="yt.editObj.group"></el-input>
					</el-form-item>
					<el-form-item :label="$t('dianjianneirong')" required="required">
						<el-input type="textarea" v-model="yt.editObj.content"></el-input>
					</el-form-item>
					<el-form-item :label="$t('dianjianzhouqi')" required="required">
						<el-input v-model="yt.editObj.remindTxt" suffix-icon="el-icon-arrow-down" :readonly="true"
							@click.native="showZhouqiDialog()">
						</el-input>
					</el-form-item>
					<el-form-item :label="$t('shifouqiyong')" required>
						<el-select v-model="yt.editObj.enable">
							<el-option :label="$t('shi')" :value="true"></el-option>
							<el-option :label="$t('fou')" :value="false"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item :label="$t('zhuyishixiang')">
						<el-input type="textarea" v-model="yt.editObj.attention"></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="yt.editObj.loading" size="mini"
						@click="yt.req('POST','/web/equipment/check/standard/update')" type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
			</template>
			<template v-if="yt.editObj.action == 'chongzhidianjianbiaozhun'">
				<div class="dialog-scroller">
					<yi_cross_select multiple :component="'web_base_equipment_list'" :min="1"
						:ids.sync="yt.editObj.equipmentIds" :isInput="false">
					</yi_cross_select>
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="yt.editObj.loading" size="mini"
						@click="yt.req('POST','/web/equipment/check/standard/reset')" type="primary">
						{{$t('quedingchongzhi')}}
					</el-button>
				</span>
			</template>

			<!-- 班次 -->
			<template v-if="yt.editObj.action == 'banci'">
				<div class="dialog-scroller">
					<shift_setting :shift="yt.editObj"></shift_setting>
				</div>
			</template>
		</el-dialog>

		<!-- 点检周期弹框 -->
		<el-dialog v-if="isShowZhouQiDialog" :show-close="true" :title="$t('dianjianzhouqi')"
			:visible.sync="isShowZhouQiDialog" :close-on-click-modal="false" append-to-body="append-to-body"
			style="justify-content: center;">
			<el-form :inline="true" :model="yt.editObj" ref="form" size="mini" :label-width="labelWidth">
				<el-form-item :label="$t('tixingfangshi')" required label-width="200px">
					<el-select v-model="yt.editObj.remindType" @change="changeRemindType">
						<el-option v-for="(item, index) in modes" :key="index" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item v-for="(item, index) in yt.editObj.remindList" :key="index" :label="$t(item.name)"
					required label-width="200px">
					<el-time-picker v-model="yt.editObj.remindList[index]['time']" :placeholder="$t('qingxuanze')"
						format='HH:mm' value-format="HH:mm" :clearable="false">
					</el-time-picker>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="closeZhouQiDialog()">{{$t("quxiao")}}</el-button>
				<el-button size="mini" @click="save()" type="primary">
					{{ $t("baocun") }}
				</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import shift_setting from '@@/pages/web/base/shift/shift_setting'
	export default {
		name: 'web_base_check_standard',
		components: {
			shift_setting
		},
		created() {
			setTimeout(() => {
				this.yt.get(1);
				this.getShiftByCustomer();
				this.getCustomerList();
			}, 300)
		},
		data() {
			return {
				list: [],
				// organizationList: [],
				customerList: [],
				shiftList: [],
				columns: [{
					label: 'shebeimingcheng',
					prop: 'equipmentName',
					width: 130
				}, {
					label: 'dianjianfenzu',
					prop: 'group',
					width: 130
				}, {
					label: 'dianjianneirong',
					prop: 'content',
				}, {
					label: 'zhuyishixiang',
					prop: 'attention',
				}, {
					label: 'dianjianzhouqi',
					type: 'slot',
					width: 220,
				}, {
					label: 'chuangjianshijian',
					prop: 'createTime',
					type: 'time',
					width: 220,
				}],
				isShowZhouQiDialog: false,
				labelWidth: "100px",
				timeList: [],
			}
		},
		computed: {

			modes() {
				return [{
						label: this.$t("antian"),
						value: 1
					},
					{
						label: this.$t('anbanci'),
						value: 2
					}
				]
			}
		},
		
		// filters: {
		//   // 过滤点检周期
		//   filterRemind(value) {
		//     if (!isArray(value)) {
		//       return ''
		//     }
		//     if (value.length == 0) {
		//       return ''
		//     }
		//     if (value[0]['remindType'] == 1) {
		//       return '按天-' + value[0]['time']
		//     } else {
		//       return "按班次-" + value.map(item => {
		//         return item.name + item.time
		//       }).join(" ")
		//     }
		//   }
		// },
		watch: {
			// // 监听点检周期
			// "yt.editObj.remindType": {
			//   handler(n, o) {
			//     if (o !== undefined) {
			//       console.log('666', o)
			//       if (n === 2) {
			//         this.$set(this.yt.editObj, 'remindList', [])
			//         this.getTimeList()
			//       }
			//       if (n === 1) {
			//         let data = [{
			//           "name": this.$t('tixingshijian'),
			//           "remindType": 1,
			//           "time": ""
			//         }]
			//         this.$set(this.yt.editObj, 'remindList', data)
			//       }
			//     }
			//   },
			//   immediate: false
			// },
			// 监听点检周期弹框
			isShowZhouQiDialog: {
				handler(n, o) {
					if (n) {
						if (this.yt.editObj.remindList && this.yt.editObj.remindList.length > 0) {
							// 早班
							if (this.yt.editObj.remindList[0]['remindType'] === 1) {
								console.log('aaaaaaaaaaaaaaa', this.yt.editObj.remindList)
								this.$set(this.yt.editObj, 'remindList', [{
									name: this.$t('tixingshijian'),
									remindType: 1,
									time: this.yt.editObj.remindList[0]['time']
								}])
							} else {
								console.log('cccccccccccccc', this.yt.editObj.remindList)
								const data = []
								for (let i = 0; i < this.yt.editObj.remindList.length; i++) {
									data.push({
										name: this.yt.editObj.remindList[i]['shift']['name'].concat(this.$t(
											'tixingshijian')),
										remindType: 2,
										time: this.yt.editObj.remindList[i]['time'],
										shiftId: this.yt.editObj.remindList[i]['shift']['id']
									})
								}
								this.$set(this.yt.editObj, 'remindList', data)
							}
						} else {
							this.$set(this.yt.editObj, 'remindType', 1)
							let data = [{
								"name": this.$t('tixingshijian'),
								"remindType": 1,
								"time": ""
							}]
							this.$set(this.yt.editObj, 'remindList', data)
						}

					}
				},
				immediate: false
			}
		},
		
		methods: {
		
			changeRemindType(value) {
				this.$set(this.yt.editObj, 'remindTxt', '')
				this.$set(this.yt.editObj, 'remindList', [])
				if (value === 2) {
					this.getTimeList()
				}
				if (value === 1) {
					let data = [{
						"name": this.$t('tixingshijian'),
						"remindType": 1,
						"time": ""
					}]
					this.$set(this.yt.editObj, 'remindList', data)
				}
			},
			beforeShowBianjiDialog() {
				let label = ''
				if (this.yt.editObj.remindType == 1) {
					label = this.$t('antian') + '-' + this.yt.editObj.remindList[0]['time']
				}
				if (this.yt.editObj.remindType == 2) {
					label = this.$t('anbanci') + "-" + this.yt.editObj.remindList.map(item => {
						return item.shift.name + item.time
					}).join(" ")
				}
				this.$set(this.yt.editObj, 'remindTxt', label)
				return this.yt.editObj
			},
			async getCustomerList() {
				let response = await this.http.get('/web/customer/page', {
					params: {
						pageNum: 1,
						pageSize: 1000
					}
				})
				this.customerList = response.data.rows
			},
			// async getOrganizationList() {
			// 	let response = await this.http.get('/web/setting/org/page', {
			// 		params: {
			// 			pageNum: 1,
			// 			pageSize: 1000
			// 		}
			// 	})
			// 	this.organizationList = response.data.rows
			// },
			async getShiftByCustomer() {
				let response = await this.http.get('/web/setting/shift/page', {
					params: {
						pageNum: 1,
						pageSize: 10000
					}
				})
				this.shiftList = response.data.rows;
			},
			// 重置
			clear() {
				this.yt.conditions = {
					pageNum: 1,
					pageSize: 10
				}
				this.yt.get(1)
			},
			// 保存点检周期
			save() {
				this.isShowZhouQiDialog = false
				let label = ''
				if (this.yt.editObj.remindType == 1) {
					label = this.$t('antian') + '-' + this.yt.editObj.remindList[0]['time']
				}
				console.log(this.yt.editObj.remindList)
				if (this.yt.editObj.remindType == 2) {
					label = this.$t('anbanci') + '-' + this.yt.editObj.remindList.map(item => {
						return item.name + item.time
					}).join(" ")
				}
				this.$set(this.yt.editObj, 'remindTxt', label)
			},
			// 打开点检周期
			showZhouqiDialog() {
				this.isShowZhouQiDialog = true
			},
			// 关闭点检周期
			closeZhouQiDialog() {
				this.isShowZhouQiDialog = false
			},
			// 获取班次
			async getTimeList() {
				let response = await this.http('/web/setting/shift/getShiftByCustomer')
				if (response.code == 200 && response.data.length != 0) {
					let data = []
					for (let i = 0; i < response.data.length; i++) {
						data.push({
							"name": response.data[i]['name'].concat(this.$t('tixingshijian')),
							"remindType": 2,
							"shiftId": response.data[i]['id'],
							"time": ""
						})
					}
					this.$set(this.yt.editObj, 'remindList', data)
				}
			},
			// 过滤点检周期
			filterRemind(value) {
				if (!isArray(value)) {
					return ''
				}
				if (value.length == 0) {
					return ''
				}
				if (value[0]['remindType'] == 1) {
					return this.$t('antian') + "-" + value[0]['time']
				} else {
					return this.$t('anbanci') + '-' + value.map(item => {
						return item.name + item.time
					}).join(" ")
				}
			}
		}
	};
</script>
